import React from 'react';
import { Container } from './styles';
import { AddSharp } from '@material-ui/icons';

interface IAddButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
}

const AddButton: React.FC<IAddButtonProps> = ({...rest}) => {
    return (
        <Container {...rest}>
            <AddSharp />
        </Container>
    )   
}

export default AddButton;
